module.exports = {
    //Common Button
    "ADV_BTN_SEARCH": "ค้นหา",
    "ADV_BTN_CLEAR": "ล้างข้อมูล",
    "ADV_BTN_ADD": "เพิ่ม",

    "ADV_ACTIVE": "ใช้งาน",
    "ADV_INACTIVE": "ไม่ใช้งาน",
}
